import React from 'react';
import loadable from '@loadable/component';

import { ModuleSelectorProps } from 'modules/shared/types';

export const ModuleSelector: React.FC<ModuleSelectorProps> = ({ structureNode, ...rest }: ModuleSelectorProps) => {
    switch (structureNode.contentTemplate) {
        case 'MariageEntry': {
            const MariageModule = loadable(() =>
                import(/* webpackChunkName: "mariage" */ '../../../../../mariage/mariage'),
            );
            return <MariageModule sourceStructureNode={structureNode} {...rest} />;
        }
        case 'DonsEntry': {
            const EspacePersoModule = loadable(() => import(/* webpackChunkName: "dons" */ '../../../../../dons/dons'));
            return <EspacePersoModule sourceStructureNode={structureNode} {...rest} />;
        }
        case 'ListesEntry': {
            const ListesModule = loadable(() =>
                import(/* webpackChunkName: "listes" */ '../../../../../listes/listes'),
            );
            return <ListesModule sourceStructureNode={structureNode} {...rest} />;
        }
        case 'CatalogueEntry': {
            const CatalogueModule = loadable(() =>
                import(/* webpackChunkName: "catalogue" */ '../../../../../catalogue/catalogue'),
            );
            return <CatalogueModule sourceStructureNode={structureNode} {...rest} />;
        }
        default:
            return <React.Fragment>Module not found</React.Fragment>;
    }
};
